export const THERAPIST_LIST_STATE = 'therapistListState';
export const ASSESSMENT_LIST_STATE = 'assessmentListState';
